<template>
	<div class="panel_settlement">
		<div style="padding-top:7px;">
			<span class="priceItem">
				<span class="label">总计：</span>
				<span class="price">￥{{money}}</span>
			</span>
			<span class="priceItem">
				<span class="label">优惠金额：</span>
				<span class="price">￥{{$public.jian(money,activityMoney)}}</span>
			</span>
		</div>
		<div>
			<span class="priceItem" style="margin-right: 20px;">
				<span class="label">应付金额：</span>
				<span class="price" style="color:#FF2F2F;">￥{{activityMoney}}</span>
			</span>
			<el-button style="width:80px;" type="warning" size="small" plain @click="openBeizhu">备注</el-button>
			<el-button style="width:100px;" type="warning" size="small" plain @click="submitOrder">生成订单</el-button>
			<el-button style="width:120px;" type="warning" size="small" @click="submitOrderAndSettlement">挂号并支付</el-button>
		</div>
		<!-- 备注弹窗 -->
		<div v-if="drawerRemark_state">
			<drawerRemark :type="'guahao'" @submit="submit_drawerRemark"></drawerRemark>
		</div>
		<!-- 结算 -->
		<div v-if="dialogSettlement_state">
			<dialogSettlement :type="'order'" :orderId="curOrder._id" @submit="submit_dialogSettlement"></dialogSettlement>
		</div>
	</div>
</template>
<script>
	import dialogSettlement from "../../../../components/dialog_settlement.vue"
	import drawerRemark from "../drawer/remark.vue"
	export default {
		components:{dialogSettlement,drawerRemark},
		data(){
			return{
				// 备注
				drawerRemark_state:false,
				// 结算
				dialogSettlement_state:false,
				curOrder:{},
				// 是否直接结算
				direct:false,
			}
		},
		computed:{
			userInfo(){
				if(this.$store.state.mendian.userInfo._id){
					return this.$store.state.mendian.userInfo;
				}else{
					return {
						basic_info:{},
						card_info:{},
						company_info:{},
						operation_info:{},
						pets_info:[],
						club_card:{}
					}
				}
			},
			curPetId(){
				return this.$store.state.mendian.curPetId;
			},
			curPetInfo(){
				return this.$store.getters['mendian/curPetInfo'];
			},
			addParams(){
				return this.$store.state.guahao.addParams;
			},
			money(){
				return this.$store.state.guahao.money;
			},
			activityMoney(){
				return this.$store.state.guahao.activityMoney;
			},
			remark(){
				return this.$store.state.guahao.remark;
			},
			
		},
		mounted(){
		},
		methods:{
			submitOrderAndSettlement(){
				this.direct = true;
				this.submitOrder();
			},
			// 创建订单
			submitOrder(){
				// if(!this.addParams.doctor){
				// 	this.$message({
				// 		message: '请选择医生',
				// 		type: 'error'
				// 	});
				// 	return ;
				// }
				// if(!this.addParams.department){
				// 	this.$message({
				// 		message: '请选择科室',
				// 		type: 'error'
				// 	});
				// 	return ;
				// }
				// if(!this.addParams.room){
				// 	this.$message({
				// 		message: '请选择诊室',
				// 		type: 'error'
				// 	});
				// 	return ;
				// }
				if(this.addParams.isTransfer!==1){
					if(this.$public.isNull(this.addParams.curBingli)){
						this.$message({
							message: '复诊或转诊必须关联病例编号',
							type: 'error'
						});
						return ;
					}
				}
				if(!this.addParams.skuItem||!this.addParams.skuItem.service_objectId){
					this.$message({
						message: '请选择挂号服务',
						type: 'error'
					});
					return ;
				}
				let salesMans = []
				if(Number(this.activityMoney)!==0){
					if(this.$public.isNull(this.addParams.handlerId)){
						this.$message({
							message: '请选择销售人员',
							type: 'error'
						});
						return ;
					}
					for(let i=0;i<this.addParams.handlerId.length;i++){
						let arr = this.addParams.handlerId[i].split(',')
						salesMans.push({"userId": arr[0],"userName": arr[1]})
					}
				}
				let params = {
					"departmentId": this.addParams.department.split(',')[0], 
					"departmentName": this.addParams.department.split(',')[1],
					"memberId": this.userInfo._id,
					"memberName": this.userInfo.basic_info.nick_name,
					"memberMobile": this.userInfo.basic_info.user_mobile,
					"petId": this.curPetInfo._id,
					"petName": this.curPetInfo.nick_name,
					"classType": this.curPetInfo.apply_type.value,
					"className": this.curPetInfo.apply_type.title,
					"typeName": this.curPetInfo.category_info.name, // 宠物种类
					"sex": this.curPetInfo.pet_sex,
					"birthDay": this.curPetInfo.bron_date,
					"doctorId": this.addParams.doctor.split(',')[0],
					"doctorName": this.addParams.doctor.split(',')[1],
					"remark": this.remark,
					// "isTransfer": this.addParams.isTransfer||false,  // 是否转诊
					registrationType: this.addParams.isTransfer,  // 挂号类型 1初诊；2复诊；3转诊
					linkCaseNumber:this.addParams.curBingli,  // 复诊以及转诊所关联的病例编号
					// "roomId": this.addParams.room.split(',')[0],
					// "roomName": this.addParams.room.split(',')[1],
					"serviceId": this.addParams.serviceItem.serviceId,
					"serviceName": this.addParams.serviceItem.title,
					"serviceObjectId": this.addParams.skuItem.service_objectId,
					"serviceObjectName": this.addParams.skuItem.service_objectName,
					"categoryId": this.addParams.serviceItem.category_info._id,
					"categoryName":this.addParams.serviceItem.category_info.name,
					"salesMans": salesMans
				}
				let loading = this.$loading()
				this.$http.post('/api/Registration/Insert', params).then(res => {
					loading.close();
					if (res.code == 0) {
						if(this.direct){
							if(Number(this.activityMoney)!==0){
								this.curOrder = res.data;
								this.dialogSettlement_state = true;
							}else{
								this.$message({
									message: '操作成功',
									type:'success'
								});
								this.$store.commit('guahao/set_type','list')
								this.$store.dispatch('mendian/getJiedaiLength')
							}
						}else{
							this.$message({
								message: '操作成功',
								type:'success'
							});
							this.$store.commit('guahao/set_type','list')
							this.$store.dispatch('mendian/getJiedaiLength')
						}
					}
				})
			},
			// 备注
			openBeizhu(){
				this.drawerRemark_state=true;
			},
			submit_drawerRemark(){
				this.drawerRemark_state=false;
			},
			// 结算
			submit_dialogSettlement(a){
				this.dialogSettlement_state = false;
				if(a=='cancel'){
					console.log(a)
				}else if(a=='fail'){
					this.$message({
						message: '结算失败',
						type: 'error'
					});
				}else if(a=='success'){
					this.$message({
						message: '结算成功',
						type: 'success'
					});
					this.$store.dispatch("mendian/getUserInfo",this.userInfo._id)
				}
				this.$store.commit('guahao/set_type','list')
			},
		}
	}
</script>
<style scoped lang="scss">
.panel_settlement{
	display: flex;
	justify-content: space-between;
	padding:10px 20px;
	background-color: #fff;
	box-shadow: 0 -3px 3px 0px #f5f5f5;
	.priceItem{
		display: inline-flex;align-items: center;
		margin-right: 40px;
		.label{
			font-size: 14px;color:$fontColor;
		}
		.price{
			font-size: 20px;color:$fontColor;
		}
	}
}
</style>
